import actions from "./actions";

const {
    FETCH_EMAIL_GROUPS,
    FETCH_EMAIL_GROUP,
    RESET_EMAIL_GROUP_FORM
} = actions;

const initState = {
    emailGroups: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    emailGroup: {
        _id: null,
        name: '',
        description: '',
        members: [],
        status: 'active'
    }
};

const EmailGroupReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_EMAIL_GROUPS:
            return {
                ...state,
                emailGroups: data
            };
        case RESET_EMAIL_GROUP_FORM:
            return {
                ...state,
                emailGroup: initState.emailGroup
            };
        case FETCH_EMAIL_GROUP:
            return {
                ...state,
                emailGroup: data
            };
        default:
            return state;
    }
};

export default EmailGroupReducer;